/**
 * tabs.js — tab theo mẫu ARIA (mục 12): bấm hoặc mũi tên trái/phải để đổi tab,
 * Home/End nhảy đầu/cuối. Chỉ tab đang chọn nằm trong tab order (roving tabindex).
 *
 * Markup: [role=tablist] > button[role=tab][aria-controls][aria-selected]
 *         + [role=tabpanel][id][hidden]
 * Không có JS thì mọi panel trừ panel đầu bị hidden — vì vậy panel đầu KHÔNG đặt
 * hidden trong HTML, nội dung chính luôn đọc được.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    [].slice.call(document.querySelectorAll('[role="tablist"]')).forEach(function (list) {
        var tabs = [].slice.call(list.querySelectorAll('[role="tab"]'));
        if (!tabs.length) return;

        function select(tab, focus) {
            tabs.forEach(function (t) {
                var on = t === tab;
                t.setAttribute('aria-selected', on ? 'true' : 'false');
                t.setAttribute('tabindex', on ? '0' : '-1');
                var panel = document.getElementById(t.getAttribute('aria-controls'));
                if (panel) panel.hidden = !on;
            });
            if (focus) tab.focus();
            list.dispatchEvent(new CustomEvent('tabs:change', { detail: { tab: tab }, bubbles: true }));
        }

        // Hàng tab cuộn ngang khi chật (mobile): tab vừa chọn mà khuất một phần thì kéo vào khung.
        // Chỉ cuộn ngang trong hàng tab — scrollIntoView sẽ kéo cả trang theo chiều dọc.
        function reveal(tab) {
            if (list.scrollWidth <= list.clientWidth) return;
            var box = list.getBoundingClientRect();
            var rect = tab.getBoundingClientRect();
            if (rect.left < box.left) list.scrollBy({ left: rect.left - box.left - 16, behavior: 'smooth' });
            else if (rect.right > box.right) list.scrollBy({ left: rect.right - box.right + 16, behavior: 'smooth' });
        }

        tabs.forEach(function (tab, index) {
            tab.addEventListener('click', function () {
                select(tab, false);
                reveal(tab);
            });

            tab.addEventListener('keydown', function (event) {
                var target = null;
                if (event.key === 'ArrowRight') target = tabs[(index + 1) % tabs.length];
                else if (event.key === 'ArrowLeft') target = tabs[(index - 1 + tabs.length) % tabs.length];
                else if (event.key === 'Home') target = tabs[0];
                else if (event.key === 'End') target = tabs[tabs.length - 1];
                if (!target) return;
                event.preventDefault();
                select(target, true);
                reveal(target);
            });
        });

        var selected = tabs.filter(function (t) {
            return t.getAttribute('aria-selected') === 'true';
        })[0];
        select(selected || tabs[0], false);
    });
})();
